// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2hPce","title":"Images90_title__1pK7I","images":"Images90_images__1p2hZ"};